export const CONTACT_INFO_CATEGORY_PHONE = 'phone';
export const CONTACT_INFO_CATEGORY_BILLING_EMAIL = 'billing_email';